module.exports = __webpack_public_path__ + "img/confiamos.96d4de87.webp";